import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-buy-charge',
  templateUrl: './buy-charge.component.html',
  styleUrls: ['./buy-charge.component.scss']
})
export class BuyChargeComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public loading2: boolean = false;
  public amount: number = 0;
  public amount2: number = 0;
  public subscription: Subscription | any;
  public user_id!: number;
  public server!: any;
  public server_main!: string;
  public creator!: number;
  constructor(
    public serverService: ServerService,
    public router: Router,
    public messageService: MessageService,
    public _dialogRef: MatDialogRef<BuyChargeComponent>,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    if (dialog_data) {
      this.creator = dialog_data.creator;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  charge() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var obj = {
      address: 6367,
      'sum': this.amount2 / 10,
      'user_id': this.user_id,
      'creator': this.creator,
      'type': 'sms',
      'account_month': 1
    }
    this.loading2 = true;
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.charge2(res['id']);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  charge2(bascket_id: number) {
    var obj = {
      'site': this.serverService.get_site(),
      'sum': this.amount2 / 10,
      'amount2': this.amount / 10,
      'user_id': this.user_id,
      'bascket_id': bascket_id, number: 1
    }
    this.subscription = this.serverService.post_address(this.server_main, 'pay', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          window.location.href = res['address'];
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_charge2() {
    this.amount2 = this.amount * 10 / 100 + this.amount;
  }
  close() {
    this._dialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}